/**
 * Lightweight formatter for AskGuru assistant replies (plain + simple markdown lists).
 */

/**
 * @param {string} text
 * @returns {Array<{ type: 'text' | 'bold'; value: string }>}
 */
export function splitInlineFormatting(text) {
  const parts = [];
  const re = /\*\*(.+?)\*\*/g;
  let last = 0;
  let match = re.exec(text);
  while (match) {
    if (match.index > last) {
      parts.push({ type: 'text', value: text.slice(last, match.index) });
    }
    parts.push({ type: 'bold', value: match[1] });
    last = match.index + match[0].length;
    match = re.exec(text);
  }
  if (last < text.length) {
    parts.push({ type: 'text', value: text.slice(last) });
  }
  return parts.length ? parts : [{ type: 'text', value: text }];
}

/**
 * @param {string} text
 * @returns {Array<{ type: 'p' | 'ol' | 'ul'; items?: string[]; text?: string }>}
 */
export function parseBhriguReply(text) {
  const lines = String(text || '').split('\n');
  /** @type {Array<{ type: 'p' | 'ol' | 'ul'; items?: string[]; text?: string }>} */
  const blocks = [];
  let i = 0;

  const isNumbered = (line) => /^\d+\.\s/.test(line);
  const isBullet = (line) => /^[-*•]\s/.test(line);

  while (i < lines.length) {
    const trimmed = lines[i].trim();
    if (!trimmed) {
      i += 1;
      continue;
    }

    if (isNumbered(trimmed)) {
      const items = [];
      while (i < lines.length && isNumbered(lines[i].trim())) {
        items.push(lines[i].trim().replace(/^\d+\.\s*/, ''));
        i += 1;
      }
      blocks.push({ type: 'ol', items });
      continue;
    }

    if (isBullet(trimmed)) {
      const items = [];
      while (i < lines.length && isBullet(lines[i].trim())) {
        items.push(lines[i].trim().replace(/^[-*•]\s*/, ''));
        i += 1;
      }
      blocks.push({ type: 'ul', items });
      continue;
    }

    const paraLines = [];
    while (i < lines.length) {
      const t = lines[i].trim();
      if (!t) break;
      if (isNumbered(t) || isBullet(t)) break;
      paraLines.push(t);
      i += 1;
    }
    const paraText = paraLines.join(' ');
    const inlineNumbered = paraText.match(/\d+\.\s/g);
    if (inlineNumbered && inlineNumbered.length >= 2) {
      const items = paraText
        .split(/(?=\d+\.\s)/)
        .map((s) => s.replace(/^\d+\.\s*/, '').trim())
        .filter(Boolean);
      if (items.length >= 2) {
        blocks.push({ type: 'ol', items });
        continue;
      }
    }
    blocks.push({ type: 'p', text: paraText });
  }

  return blocks;
}
